import { createContext } from "react";
import { ListTableSort } from "sprint-common-web";

import { TvSeasonDetails, TvSeriesDetails } from "../../../TvSeriesDetails";
import { SeasonListingFilters } from "../season-listing/SeasonListingFilters";
import { SeasonListingItem } from "../season-listing/SeasonListingItem";

interface ITvSeriesPageContext {
    seasonsToMerge: SeasonListingItem[];
    listingItems: SeasonListingItem[];
    isLoading: boolean;
    tvSeries?: TvSeriesDetails;
    totalItems: number;
    filters: SeasonListingFilters;
    clearFilters(): void;
    addNewSeason(newSeason: TvSeasonDetails): void;
    editTvSeries(title: string, year?: number): void;
    setSort(sort: ListTableSort): void;
    setPage(page: number): void;
    setPageSize(pageSize: number): void;
    setOrphanedOnly(orphanedOnly?: boolean): void;
    setIncludeMerged(includeMerged?: boolean): void;
    clearSeasonsToMerge(): void;
    addSeasonToMergeList(seasonItem?: SeasonListingItem): void;
    removeSeasonFromMergeList(seasonItem: SeasonListingItem): void;
    updateListAfterMerge(newSeasonId: string): Promise<void>;
}

const defaultTvSeriesPageContext: ITvSeriesPageContext = {} as ITvSeriesPageContext;

export const TvSeriesPageContext = createContext<ITvSeriesPageContext>(defaultTvSeriesPageContext);
